import { types } from './types'
import { getDefaultState } from './state'

export const mutations = {
  [types.SET_CART_ITEMS] (state, products) {
    state.items = products
  },

  [types.SET_CART_ID_FROM_COOKIE] (state) {
    if (!state.id) {
      state.id = this.$cookies.get('cart-id')
    }
  },

  [types.SET_CART_ID] (state, cartId) {
    state.id = cartId

    this.$cookies.set('cart-id', cartId, {
      path: '/',
      maxAge: this.$config.exparingCartInCookie,
      secure: this.$config.env === 'preprod' || this.$config.env === 'prod',
    })
  },

  [types.SET_APPLIED_COUPONS] (state, appliedCoupons) {
    state.appliedCoupons = appliedCoupons
  },

  [types.SET_APPLIED_GIFT_CARDS] (state, appliedGiftCards) {
    state.appliedGiftCards = appliedGiftCards
  },

  [types.SET_CART_PRICES] (state, prices) {
    state.prices = prices
  },

  [types.SET_CART_MEDICLUB_PRICES] (state, mediclubPrices) {
    state.mediclubPrices = mediclubPrices
  },

  [types.SET_CART_NO_MEDICLUB_PRICES] (state, noMediclubPrices) {
    state.noMediclubPrices = noMediclubPrices
  },

  [types.SET_CART_RESERVATION_TIMEOUT] (state, timeout = null) {
    state.reservationTimeout = timeout
  },

  [types.SET_CART_REMOVED_ITEMS] (state, items = []) {
    state.removedItems = items
  },

  [types.SET_CART_RESERVATION_INTERVAL] (state, interval) {
    state.reservationInterval = interval
  },

  [types.UPDATE_CART_RESERVATION_TIME] (state) {
    state.now = Date.now()
  },

  [types.SET_CURRENT_STEP] (state, step) {
    state.currentStep = step
  },

  [types.SET_CART_LOADED] (state, cart) {
    state.cartLoaded = cart
  },

  [types.REMOVE_CART_ITEMS] (state, products) {
    state.items = products
  },

  [types.RESET_CART] (state) {
    Object.assign(state, getDefaultState())
  },

  [types.PAYMENT_METHODS] (state, paymentMethods = []) {
    state.paymentMethods = paymentMethods
  },

  [types.SET_PAYMENT_METHOD_ID] (state, id) {
    state.paymentMethodId = id
  },

  [types.SET_SELECTED_PAYMENT] (state, selectedPayment = null) {
    state.selectedPayment = selectedPayment
  },
  [types.IS_REGISTERED_ON_CHECKOUT] (state, isRegisteredOnCheckout = null) {
    state.isRegisteredOnCheckout = isRegisteredOnCheckout
  },

  [types.SET_CART_ATTACHMENTS] (state, payload) {
    state.attachments = payload
  },

  [types.IS_CART_READ_ONLY] (state, payload) {
    state.isCartReadOnly = payload
  },

  [types.SET_SHIPPING_METHOD_READ_ONLY] (state, payload) {
    state.setShippingMethodReadOnly = payload
  },

  [types.SET_BILLING_ADDRESS] (state, payload) {
    state.billingAddress = payload
  },

  [types.SET_AVAILABLE_PAYMENT_METHODS] (state, payload) {
    state.availablePaymentMethod = payload
  },
}
